export function percentChange(a: number, b: number) {
  return Math.floor(((a - b) / a) * 100);
}

export function formatCurrency(a: number) {
  return "$" + Math.abs(Math.floor(a)).toLocaleString();
}

export const getArrayOfNumbersDivisbleByN = (
  startNum: number,
  endNum: number,
  numberToDivideBy: number,
) => {
  let finalArray = [];
  for (let currentNum = startNum; currentNum <= endNum; currentNum++) {
    if (currentNum % numberToDivideBy === 0) {
      finalArray.push(currentNum);
    }
  }
  return finalArray;
};
